import React from 'react';

type Props = {
  time: string | null;
};

export const TimeSentRow: React.FC<Props> = ({ time }): JSX.Element => {
  const attrs = {
    wrapper: { className: 'message-sent-row' },
  };

  return <div {...attrs.wrapper}>{time}</div>;
};
